(function () {
    angular.module("skillBuilderSaaS")
        .controller("OnlineExamAddAttemptModalCtrl", ["$scope", "$stateParams", "onlineExamsHistoryResource", "messageService", onlineExamAddAttemptModalCtrl]);
    function onlineExamAddAttemptModalCtrl($scope, $stateParams, onlineExamsHistoryResource, messageService) {
        var vm = this;
        vm.showErrors = false;
        vm.save = function (isValid) {
            vm.showErrors = true;
            if (isValid) {
                onlineExamsHistoryResource.addExamAttempts({ person: $stateParams.person, assignmentId: $stateParams.assignmentId, activationNumber: $stateParams.activationNumber }, vm.formData, function (result) {
                    $scope.$close(result);
                    messageService.success("common.changesSaved");
                }, function (error) {
                    messageService.error(error);
                });
            }
        };
    }
}());
